<!-- eslint-disable ts/ban-ts-comment -->
<script setup lang='ts'>
import { LICENSE_AREA_LIST } from '@/shared/constants'

const props = withDefaults(defineProps<{
  modelValue?: string
}>(), {})
const emits = defineEmits({
  'update:modelValue': (_data: string) => true,
})
const showModal = ref(false)

function select(value: string) {
  emits('update:modelValue', value)
  showModal.value = false
}
</script>

<template>
  <button v-bind="$attrs" @click="showModal = true">
    <slot>
      {{ props.modelValue ?? '选择车辆所属地' }}
    </slot>
  </button>
  <n-modal v-model:show="showModal">
    <n-card
      size="medium" :bordered="false"
      title="选择车辆所属地"
      aria-modal="true"
      class="w-120 rounded-md"
      closable :on-close="() => showModal = false"
    >
      <div class="flex flex-wrap">
        <button
          v-for="v in LICENSE_AREA_LIST" :key="v.value"
          class="border-1 border-slate-2 rounded mr-sm mb-sm px-sm py-1"
          :class="props.modelValue === v.text ? 'bg-blue-5 text-white' : 'btn-white'"
          @click="select(v.text)"
        >
          {{ v.text }}
        </button>
      </div>
    </n-card>
  </n-modal>
</template>

<style lang='scss' scoped>

</style>
